export const video = [
    {
        id: 1,
        name: "Գազային օրենքների փորձնական ուսումնասիրումը",
        info: "https://www.youtube.com/watch?v=PFLELVDOzZE",
        menuItemId: 3
    },
    {
        id: 2,
        name: "Թեք հարթության ՕԳԳ–ի որոշումը",
        info: "https://www.youtube.com/watch?v=om5zCr_99vc",
        menuItemId: 3
    },

]